// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/recipes/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/recipes/deleteIngredient */
export const useDeleteIngredient = makeBackendHook('recipes', 'deleteIngredient')

/** POST /api/rpc/recipes/deleteIngredientCategory */
export const useDeleteIngredientCategory = makeBackendHook('recipes', 'deleteIngredientCategory')

/** POST /api/rpc/recipes/deleteLabelRecipe */
export const useDeleteLabelRecipe = makeBackendHook('recipes', 'deleteLabelRecipe')

/** POST /api/rpc/recipes/getIngredientCategories */
export const useGetIngredientCategories = makeBackendHook('recipes', 'getIngredientCategories')

/** POST /api/rpc/recipes/getIngredients */
export const useGetIngredients = makeBackendHook('recipes', 'getIngredients')

/** POST /api/rpc/recipes/getLabelRecipe */
export const useGetLabelRecipe = makeBackendHook('recipes', 'getLabelRecipe')

/** POST /api/rpc/recipes/getProductCosts */
export const useGetProductCosts = makeBackendHook('recipes', 'getProductCosts')

/** POST /api/rpc/recipes/getProductionPlan */
export const useGetProductionPlan = makeBackendHook('recipes', 'getProductionPlan')

/** POST /api/rpc/recipes/getRecipeLabels */
export const useGetRecipeLabels = makeBackendHook('recipes', 'getRecipeLabels')

/** POST /api/rpc/recipes/getRecipeOnlyFlavors */
export const useGetRecipeOnlyFlavors = makeBackendHook('recipes', 'getRecipeOnlyFlavors')

/** POST /api/rpc/recipes/getStationRecipes */
export const useGetStationRecipes = makeBackendHook('recipes', 'getStationRecipes')

/** POST /api/rpc/recipes/saveLabelRecipe */
export const useSaveLabelRecipe = makeBackendHook('recipes', 'saveLabelRecipe')

/** POST /api/rpc/recipes/updateIngredientsBulk */
export const useUpdateIngredientsBulk = makeBackendHook('recipes', 'updateIngredientsBulk')

/** POST /api/rpc/recipes/upsertIngredient */
export const useUpsertIngredient = makeBackendHook('recipes', 'upsertIngredient')

/** POST /api/rpc/recipes/upsertIngredientCategory */
export const useUpsertIngredientCategory = makeBackendHook('recipes', 'upsertIngredientCategory')
